<template>
<div class="modal-overlay" v-if="visible">
  <div class="modal-container">
    <div class="success-icon">
      <svg viewBox="0 0 50 50" width="70" height="70">
        <circle cx="25" cy="25" r="23" fill="#7BC67E" />
        <path d="M20 27 L25 32 L35 18" stroke="white" stroke-width="4" fill="none" />
      </svg>
    </div>
    <div class="modal-title">Role created successfully</div>
    <div class="modal-message">The role has been created successfully.</div>
    <div class="modal-actions">
      <button class="btn-ok" @click="closeModal">OK</button>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'RoleSuccessCreate',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>
<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.success-icon {
  margin: 0 auto 16px;
  width: 70px;
  height: 70px;
}
.modal-container {
  background-color: #fff;
  width: 400px;
  border-radius: 4px;
  padding: 24px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.modal-title  {
  color: #7BC67E;
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 12px;
}
.modal-message {
  color: #6B7280;
  font-size: 14px;
  margin-bottom: 24px;
  line-height: 1.5;
}
.modal-actions {
  margin-top: 8px;
}
.btn-ok {
  background-color: #FFA500;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 32px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.btn-ok:hover {
  background-color: #FF8C00;
}
</style>
